import styled from 'styled-components';
import { Button, Flex, H1, P, colors, spacing } from '@procore/core-react';

const FooterCard = styled(Flex)`
  background: ${colors.black};
  display: flex;
  padding: calc(${spacing.xxl}px * 2) calc(${spacing.xxl}px + ${spacing.lg}px);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
`;

const FooterContent = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 auto;
  text-align: left;
  max-width: 780px;
  width: 100%;
`;

const FooterTitle = styled(H1)`
  color: ${colors.white};
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 56px;
  letter-spacing: -0.75px;
  margin-bottom: ${spacing.xl}px;
`;

const FooterDescription = styled(P)`
  color: ${colors.white};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: ${spacing.xl}px;
  text-align: left;
  margin: 0;
`;

const EmailText = styled(P)`
  color: ${colors.white};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
`;

const EmailLink = styled.a`
  color: ${colors.white};
  text-decoration: underline !important;
`;

const FooterButton = styled(Button)`
  margin: 48px 0;

  @media (max-width: 768px) {
    margin: ${spacing.xl}px 0;
  }
`;

export {
  FooterCard,
  FooterContent,
  FooterTitle,
  FooterDescription,
  EmailText,
  EmailLink,
  FooterButton,
};
